/* eslint-disable import/prefer-default-export */
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import { ShareProfilesRequestBody } from './types';
import API from '../../../network';

const useShareProfiles = () => {
  const {
    mutateAsync, error, status, isPending,
  } = useMutation({
    mutationFn: async (data: ShareProfilesRequestBody) => API.getInstance().shareProfiles(data),
  });

  const shareProfiles = async (
    data: ShareProfilesRequestBody,
  ) => new Promise((resolve) => {
    const promise = mutateAsync(data).then(async () => {
      resolve(true);
    });
    toast.promise(promise, {
      loading: 'Please wait...',
      success: 'Profiles shared successfully',
      error: (err: any) => `${err?.response?.data?.message || error || 'something went wrong!'}`,
    }, {
      position: 'bottom-center',
    });
  });

  return {
    shareProfiles,
    shareProfilesPending: isPending,
    error,
    status,
  };
};

export {
  useShareProfiles,
};
